import React from 'react'
import {Helmet} from 'react-helmet-async'
import mTeam from '../images/mTeam.png'
import teamTeacher from '../images/teamTeacher.png'
import teamStudent from '../images/teamStudent.png'
import teamBegin from '../images/teamBegin.png'
import teamMobile from '../images/teamMobile.png'

const Team = () => {
  return (
    <>
       <Helmet>
        <title>Google tools</title>
        <meta
          name="description"
          content="Online Learning Microsoft Team Microsoft account Login สำนักวิทยบริการ มหาวิทยาลัยราชมงคลศรีวิชัย ระบบสนับสนุนการเรียนการสอนออนไลน์"
        />
        <link rel="canonical" href="/google" />
      </Helmet>

       <div className='container text-center' style={{ marginTop:"100px"}}>
       <img src={mTeam} className='p-2 mb-5' alt="microsoftTeam"/>
        <div className='p-4'>
        <h4>Download คู่มือการใช้งาน Microsoft Team</h4>
        </div>
        {/* <table className='table'>
            <tbody>
                <tr>
               <td> 
               <h3><i className='fa fa-download rounded-pill p-2  text-light' style={{backgroundColor:'#535BC5'}}></i></h3>
                        <a className='btn  mb-2 rounded-pill shadow text-light' style={{backgroundColor:'#535BC5',color:'#fff'}} href="/">
                         1.คู่มือการใช้งาน Microsoft Team สำหรับอาจารย์</a>
                </td>
                <td className='list-unstyled'>
                <h3><i className='fa fa-download rounded-pill p-2  text-light' style={{backgroundColor:'#535BC5'}}></i></h3>

                    <a className='btn mb-2 rounded-pill shadow' style={{backgroundColor:'#535BC5',color:'#fff'}}href="/">2.คู่มือการใช้งาน Microsoft Team นักศึกษา</a>
                </td>
            <td className='list-unstyled'>
         <a href="https://arit.rmutsv.ac.th/sites/default/files/Microsoft%20Team-Basic.pdf"> 
         <h3><i className='fa fa-download rounded-pill p-2  text-light' style={{backgroundColor:'#535BC5'}}></i></h3></a>
                <a className='btn mb-2 rounded-pill shadow' style={{backgroundColor:'#535BC5',color:'#fff'}} href="/">3.คู่มือการใช้งาน Microsoft Team ด้วยอุปกรณ์โมบาย</a></td>
            <td className='list-unstyled'>
            <h3><i className='fa fa-download rounded-pill p-2  text-light' style={{backgroundColor:'#535BC5'}}></i></h3>
                <a className='btn mb-2 rounded-pill shadow' style={{backgroundColor:'#535BC5',color:'#fff'}} href="https://arit.rmutsv.ac.th/sites/default/files/Microsoft%20Team-Basic.pdf">4.คู่มือการใช้งาน Microsoft Team เบื้องต้น</a></td>
           
                </tr>
            </tbody>
        </table> */}
        <div className='row'>
        <div className='col-lg-3 col-md-6 col-sm'>
                <a href="https://arit.rmutsv.ac.th/sites/default/files/Microsoft%20Team-Techer.pdf" target='_blank' rel="noreferrer">

                <img src={teamTeacher} className='img-card-top img-fluid' style={{borderRadius:'20px',boxShadow:'0 0 10px #ccc'}} alt="teamTeacher"/>
                </a>
        </div>
        <div className='col-lg-3 col-md-6 col-sm'>
                <a href="https://arit.rmutsv.ac.th/sites/default/files/Microsoft%20Team-Studen.pdf" target='_blank' rel="noreferrer">

                <img src={teamStudent} className='img-card-top img-fluid' style={{borderRadius:'20px',boxShadow:'0 0 10px #ccc'}} alt="teamTeacher"/>
                </a>
        </div>
        <div className='col-lg-3 col-md-6 col-sm'>
            <a href="https://arit.rmutsv.ac.th/sites/default/files/Microsoft%20Team-Basic.pdf" target="_blank" rel="noreferrer">

                <img src={teamBegin} className='img-card-top img-fluid' style={{borderRadius:'20px',boxShadow:'0 0 10px #ccc'}} alt="teamTeacher"/>
            </a>
        </div>
        <div className='col-lg-3 col-md-6 col-sm'>
            <a href="https://arit.rmutsv.ac.th/sites/default/files/Microsoft%20Team-Mobile.pdf" target="_blank" rel="noreferrer">

                <img src={teamMobile} className='img-card-top img-fluid' style={{borderRadius:'20px',boxShadow:'0 0 10px #ccc'}} alt="teamTeacher"/>
            </a>
        </div>
        </div>
       </div>

    </>
  )
}

export default Team